import React from 'react'
import { func, object } from 'prop-types'

import { Grid, Row, Col } from 'react-bootstrap'

import InputBlock from 'coact/InputBlock'

import Input from 'coact/Input'

import Block from 'coact/Block'


function HeadEditor (props) {
  const { spliter, style } = props
  const getChildProps = spliter(props)

  return (
    <div className={style['form-head']}>
      <Grid>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('key')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('type')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('lockPrice')} />
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <InputBlock {...getChildProps('name')} disabled="true" />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('brandRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('brandCode')} disabled="true" />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('supplierRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('orderCode')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('origin')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('unit')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('centerCost')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('price')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('staffPrice')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('storeCost')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('salePrice')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={8}>
            <InputBlock {...getChildProps('seriesRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('diameter')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <Block name={'S'} nameWidth={100} inputWidth={200} >
              <Input {...getChildProps('sphereMax')} />
            </Block>
          </Col>
          <Col md={4}>
            <Block name={'~S'} nameWidth={100}><Input {...getChildProps('sphereMin')} /></Block>
          </Col>
          <Col md={4}>
            <Block name={'基弧'} nameWidth={100}>
              <Input {...getChildProps('radius')} />
            </Block>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('cylinderMax')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('cylinderMin')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('replacementFrequency')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('addMax')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('addMin')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('lensColor')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('axisMax')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('axisMin')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('Ctype')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('SCMax')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('waterContent')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('packingQuantity')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('isContract')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('orderFrom')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('payType')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={8}>
            <InputBlock {...getChildProps('note')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('ragicStoreNodeId')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('ragicCenterNodeId')} />
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

HeadEditor.propTypes = {
  spliter: func.isRequired,
  style: object.isRequired,
}

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsC/HeadEditor/HeadEditor.jsx